import { handleActions } from 'redux-actions'
import { Record } from 'immutable'
import { REHYDRATE, FLUSH } from 'redux-persist'

import { onboarding } from './actions'

export const Onboarding = Record(
  {
    isLoading: false,
    selectedProTrackLevelId: null,
  },
  'Onboarding'
)

const handleRehydrate = (state: any, { payload }: any) => {
  return payload && payload.onboarding && payload.onboarding.set ? payload.onboarding.set('isLoading', false) : state
}

const handleFlush = () => {
  return new Onboarding()
}

const handleChangeIsLoading = (state: any, { payload: { isLoading } }: any) => {
  return state.set('isLoading', isLoading)
}

const handleChangeProTrack = (state: any, { payload: { proTrackLevelId } }: any) => {
  return state.set('selectedProTrackLevelId', proTrackLevelId)
}

export default handleActions(
  {
    [REHYDRATE]: handleRehydrate,
    [FLUSH]: handleFlush,
    [onboarding.changeIsLoading]: handleChangeIsLoading,
    [onboarding.changeProTrack]: handleChangeProTrack,
  },
  new Onboarding()
)
